import {http} from '@/utils';
import type {
  ActivityPay,
  ActivityRechargeAward,
  BalanceConfig,
} from '@fe-progressive/package-progressive/recharge';

export type {ActivityPay, ActivityRechargeAward, BalanceConfig};

/** 活动 Tab 选中态（后端若提供专用接口可替换） */
export const updateTabActiveStatus = async (
  _tabId: number,
  _isActive: boolean,
): Promise<boolean> => true;

/** 支付页钱包打水倍数 */
export const getMultiple = () => {
  return http.post<null, number>('/app/pay/wallet/multiple');
};

export interface VipWeekCardReward {
  bonusAmount: number;
  day: number;
  scratchCount: number;
  spinCount: number;
}

export interface VipWeekCardConfig {
  bonus: number;
  cardId: number;
  cardName: string;
  price: number;
  scratchName: string;
  vipWeekCardRewardList: VipWeekCardReward[];
}

export const getVipWeekCardConfigList = () => {
  return http.post<null, VipWeekCardConfig[]>(
    '/app/vip/getVipWeekCardConfigByDayList',
  );
};

export const getActivityPayList = (useType?: number) => {
  return http.post<{useType?: number}, Array<ActivityPay>>(
    '/app/promotion/activity/pay/list',
    {
      useType,
    },
  );
};

export const getBalanceConfig = (useType?: number) => {
  return http.post<null, Array<BalanceConfig>>(
    '/app/pay/wallet/balanceConfig',
    {
      useType,
    },
  );
};
